import { Container } from '@cgs/wge';
import { CheatManager, CheatManagerToken } from '../cheat-manager';
import { CheatPopupElementToken } from './cheat-popup';
import { CheatUISection } from './cheat-ui-section';
import { getCheatUIStyles } from './styles';

export const CheatConfigsToken = Symbol('CheatConfigs');

export class CheatConfigsUI extends CheatUISection {
  constructor(private container: Container) {
    super();

    const cheatConfigs = this.container.resolve<string[]>(CheatConfigsToken);

    if (!cheatConfigs.length) {
      return;
    }

    this.initialize();
  }
  public initialize(): void {
    const consoleEl = this.container.resolve<HTMLDivElement>(CheatPopupElementToken);

    this.initializeBaseUI(consoleEl);
    this.setupConfigsUI();
    this.setupConfigsEventListeners();
  }

  private setupConfigsUI(): void {
    const cheatConfigs = this.container.resolve<string[]>(CheatConfigsToken);

    const styles = getCheatUIStyles();
    const content = `<div style="${styles.sectionStyle}">
          <button id="applyConfig" style="${styles.buttonStyle}">Apply</button>
          <select id="configSelect" style="${styles.selectStyle}">
            ${cheatConfigs.map((value) => `<option value="${value}">${value}</option>`).join('')}
          </select>
        </div>`;

    this.contentEl.innerHTML = content;
  }

  private setupConfigsEventListeners(): void {
    const cheatManager = this.container.resolve<CheatManager>(CheatManagerToken);
    // Config event listeners
    this.getChildEl('#applyConfig')?.addEventListener('click', () => {
      const selectEl = this.getChildEl<HTMLSelectElement>('#configSelect');

      if (selectEl && selectEl.selectedOptions.length > 0) {
        cheatManager.applyConfig(selectEl.selectedOptions[0].label);
      }
    });
  }
}
